import { useCallback } from 'react';
import core, { App } from '@gin-betting/core';

import { useAppliedFilters, useMount } from 'hooks';
import { DEFAULT_TIME_PERIOD, FILTER_TIME_PERIODS } from '../../constants';

interface Output {
    currentPeriod: App.TimePeriodVariants;
    onChange: (nextPeriod: App.TimePeriodVariants) => void;
}

const {
    utils: { setSearchString, extendSearchString },
} = core;

function useFilterByTimePeriod(): Output {
    const { dateFrom } = useAppliedFilters();
    const currentPeriod =
        dateFrom &&
        FILTER_TIME_PERIODS.includes(dateFrom as App.TimePeriodVariants)
            ? (dateFrom as App.TimePeriodVariants)
            : DEFAULT_TIME_PERIOD;

    useMount(() => {
        extendSearchString('dateFrom', currentPeriod);
    });

    const onChange = useCallback(
        (nextPeriod: App.TimePeriodVariants) => {
            if (currentPeriod === nextPeriod) return;

            setSearchString({
                dateFrom: nextPeriod,
            });
        },
        [currentPeriod]
    );

    return {
        onChange,
        currentPeriod,
    };
}

export default useFilterByTimePeriod;
